import React, { useRef, useState } from 'react';
import { Box, IconButton, Popover, Typography } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import styles from './FolderIdHelpHint.module.scss';

const FolderIdHelpHint = () => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  const show = () => setOpen(true);
  const hide = () => setOpen(false);

  return (
    <>
      <IconButton
        ref={anchorRef}
        type="button"
        size="small"
        className={styles.helpBtn}
        aria-label="How to find Google Drive folder ID"
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
      >
        <HelpOutline fontSize="inherit" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        onClose={hide}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableRestoreFocus
        className={styles.popover}
        slotProps={{
          paper: {
            className: styles.popoverPaper,
            onMouseEnter: show,
            onMouseLeave: hide,
          },
        }}
      >
        <Box className={styles.content}>
          <Typography variant="subtitle2" className={styles.title}>
            How to find your Folder ID
          </Typography>
          <Typography variant="body2" className={styles.instruction}>
            Open the folder in Google Drive. Copy the ID from the browser address bar — the part
            after <code>/folders/</code>.
          </Typography>

          <div className={styles.urlBar} aria-hidden>
            <span className={styles.urlPrefix}>drive.google.com/drive/folders/</span>
            <span className={styles.urlHighlight}>1hpsowG-k2M7jkzYMQd12ytutL4uApmcM</span>
          </div>
        </Box>
      </Popover>
    </>
  );
};

export const getSchemaFieldLabel = (field) => {
  const text = `${field.label}${field.required ? ' *' : ''}`;
  if (field.key !== 'folder_id') return text;
  return (
    <span className={styles.labelWithHint}>
      {text}
      <FolderIdHelpHint />
    </span>
  );
};

export default FolderIdHelpHint;
